export enum IdentityProviderDetailsTabTypes {
    DETAILS = "details",
    COMPANY = "company",
    URL_PARAMETERS = "url-parameters",
    FEDERATED_ATTRIBUTES = "federated-attributes"
}